import React, {useState} from "react";


const FiltersContext = React.createContext();

export const FiltersProvider = ({ children }) => {
  const [category, setCategory] = useState("");
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(1000);
  const [searchInput, setSearchInput] = useState("");
    return (
    <FiltersContext.Provider
      value={{
        category,
        setCategory,
        minPrice,
        setMinPrice,
        maxPrice,
        setMaxPrice,
        searchInput,
        setSearchInput,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export const useFilters = () => React.useContext(FiltersContext);
